import { gql } from 'graphql-tag';

export const SET_ACCOUNTS_PAYABLE = gql`
  mutation Ida25dabe8db8c8c3b4f874d9a95b5eb48(
    $companyId: ID!
    $accountsUpdates: [AccountPayableUpdate!]!
  ) {
    __typename
  }
`;
